import React, { useCallback, useState, useRef } from "react";
import PropTypes from "prop-types";
import tw from "tailwind-styled-components";

import { Modal, ModalBody, ModalFooter, ModalTitle } from "../Modal";
import Button from "../Button";
import { axiosClient } from "../../redux_axios_middleware";

const Textarea = tw.textarea`
h-40
w-full
text-black
focus:ring-sky-500
focus:border-sky-500
sm:text-sm
border-gray-300
rounded-lg
shadow
`;

export default function FeedbackModal({ closeFeedbackModal }) {
  const [content, setContent] = useState("");
  const contentTextRef = useRef(null);

  const submitFeedback = useCallback(
    (content) => {
      axiosClient({
        method: "POST",
        url: "/feedback.json",
        data: { text: content },
      })
        .then(() => {
          closeFeedbackModal();
        })
        .catch((error) => {
          alert(
            `Could not submit the feedback. Please try again later. ${error}`
          );
        });
    },
    [closeFeedbackModal]
  );

  return (
    <Modal
      focusElement={contentTextRef}
      isOpened={true}
      onClose={closeFeedbackModal}
    >
      <ModalTitle>Feedback</ModalTitle>
      <ModalBody>
        <p className="mb-2">
          Please share your comments, questions, or bug reports below. Thank you
          for using Humans!
        </p>
        <Textarea
          ref={contentTextRef}
          onChange={(e) => setContent(e.target.value)}
        />
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => submitFeedback(content)} type="button">
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  );
}

FeedbackModal.propTypes = {
  closeFeedbackModal: PropTypes.func.isRequired,
};
